/// <reference path="../../resources/resources.ts" />

namespace OfficeGuy.Inputs {
    export class CreditCardValidation {
        static IsValid(CardNumber: string): boolean {
            CardNumber = CardNumber.replace(/ /g, '');
            var Length = CardNumber.length;
            if (Length == 0)
                return true;

            if (Length < 8)
                return false;

            var Sum = 0;
            // Isracard
            if (Length == 8 || Length == 9)
            {
                for (var i = Length - 1; i >= 0; i--)
                    Sum += parseInt(CardNumber.charAt(i)) * (Length - i);
                if (Sum % 11 == 0)
                    return true;
            }

            // Luhn 10
            Sum = 0;
            var Parity = Length % 2;
            for (var i = Length - 1; i >= 0; i--) {
                var Digit = parseInt(CardNumber.charAt(i));
                if (i % 2 == Parity)
                    Digit *= 2;
                if (Digit > 9)
                    Digit -= 9;
                Sum += Digit;
            }
            return (Sum % 10) == 0;
        }
    }
}

$(document).on("Teva.Init", function () {
    $.validator.addMethod("creditcard", OfficeGuy.Inputs.CreditCardValidation.IsValid, OfficeGuy.Resources.GetString("CRM", "InvalidCreditCardNumber"));
});
